import type { ButtonHTMLAttributes, ReactNode } from 'react';

export type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'ghost' | 'success';
export type ButtonSize    = 'sm' | 'md' | 'lg';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?:   ButtonVariant;
  size?:      ButtonSize;
  loading?:   boolean;
  fullWidth?: boolean;
  icon?:      ReactNode;
  iconRight?: ReactNode;
}

export function Button({
  variant   = 'secondary',
  size      = 'md',
  loading   = false,
  fullWidth = false,
  icon,
  iconRight,
  children,
  className,
  disabled,
  ...props
}: ButtonProps) {
  const cls = [
    'btn',
    `btn-${variant}`,
    size === 'sm' ? 'btn-sm' : size === 'lg' ? 'btn-full' : '',
    fullWidth ? 'btn-full' : '',
    className ?? '',
  ].filter(Boolean).join(' ');

  return (
    <button className={cls} disabled={disabled || loading} {...props}>
      {loading
        ? <span className="spinner" style={{ width: 13, height: 13, borderWidth: 1.5, flexShrink: 0 }} />
        : icon && <span style={{ display: 'flex', alignItems: 'center' }}>{icon}</span>
      }
      {children}
      {iconRight && !loading && (
        <span style={{ display: 'flex', alignItems: 'center' }}>{iconRight}</span>
      )}
    </button>
  );
}
